import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 8.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75M12 16.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.2 3.064 1.282 18.686a2.295 2.295 0 0 0-.006 2.2c.182.334.445.613.762.809s.677.3 1.045.305h17.835a2.03 2.03 0 0 0 1.044-.305c.317-.196.58-.475.762-.81a2.3 2.3 0 0 0-.006-2.2L13.8 3.065a2.15 2.15 0 0 0-.767-.78A2.03 2.03 0 0 0 12 2c-.362 0-.718.098-1.033.284-.315.187-.58.455-.767.78m2.302.75-.002-.002a.66.66 0 0 0-.23-.236A.53.53 0 0 0 12 3.5a.53.53 0 0 0-.27.076.66.66 0 0 0-.23.236l-.002.002-8.906 15.602a.8.8 0 0 0 .002.753c.06.111.143.195.232.25.086.053.178.079.268.081h17.812a.53.53 0 0 0 .268-.081.66.66 0 0 0 .232-.25.8.8 0 0 0 .002-.753z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }